import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from '@shared/translation';
import { useOptions } from '../hooks/useOptions';
import { LegacyInput } from '../internal/LegacyInput';
import type { ColumnFilterProps } from '../types';
import { useTableTexts } from '../useTableTexts';
import { AutocompletePopperComponent } from './AutocompletePopperComponent';
import { getFilterInputProps } from './util';

// Filter on options specified in `columnDef.meta.options`.
export const OptionColumnFilter = ({ column, layout }: ColumnFilterProps) => {
  const { translate } = useTranslation();
  const texts = useTableTexts();
  const options = useOptions(column);
  const value =
    options.find((option) => option.value === column.getFilterValue()) ?? null;

  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={(_, option) => {
        column.setFilterValue(option?.value);
      }}
      getOptionLabel={(option) => translate(option.label) ?? '-'}
      renderInput={(params) => (
        <LegacyInput
          {...params}
          {...getFilterInputProps(column, layout, texts)}
        />
      )}
      slots={{
        popper: AutocompletePopperComponent,
      }}
      size="small"
      sx={{
        ...(layout === 'header' && {
          '& .MuiFilledInput-root': { paddingY: '3px' },
        }),
      }}
    />
  );
};
